export default "__VITE_ASSET__DBNR_5PK__"